// extracted by mini-css-extract-plugin
var _1 = "kYMzMEwbdupetXvuECsl";
export { _1 as "container" }
